import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M543.472264 63.968016c-265.083458 0-480.015992 214.932534-480.015992 480.015992s214.932534 480.015992 480.015992 480.015992 480.015992-214.932534 480.015992-480.015992-214.932534-480.015992-480.015992-480.015992z m255.872064 511.744128h-224.143928v224.143928c0 17.911044-14.328836 31.728136-31.728136 31.728136s-31.728136-14.328836-31.728136-31.728136v-224.143928H287.6002c-17.911044 0-31.728136-14.328836-31.728136-31.728136s14.328836-31.728136 31.728136-31.728136H511.744128V287.6002c0-17.911044 14.328836-31.728136 31.728136-31.728136s31.728136 14.328836 31.728136 31.728136V511.744128h224.143928c17.911044 0 31.728136 14.328836 31.728136 31.728136s-13.305347 32.23988-31.728136 32.23988z\" fill=\"#248AFE\" p-id=\"23294\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/add.svg
// module id = 58n+
// module chunks = 58